import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { generateEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { RegistrationButtonEntityInterface } from './registration-button-entity.schema'

export const createRegistrationButton = (
  parentId: string,
  text: string,
  subText: string,
  masterBlockId?: MasterBlockIdType,
): RegistrationButtonEntityInterface => {
  return {
    ...generateEntity(
      EntityTypeEnum.RegistrationButton,
      parentId,
      masterBlockId,
    ),
    buttonType: WebsiteSettingsTypographyTypeEnum.PrimaryButton,
    iconClassNameBefore: '',
    iconClassNameAfter: '',
    alignSelf: 'center',
    text,
    subText,
    width: 'auto',
    boxShadow: 'none',
    mobileWidth: '100%',
    mobileAlignSelf: 'center',
    mobileBoxShadow: 'none',
  }
}
